<template>
    <div class="helper-icon">
        ?
        <div :class="position">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "HelperTooltip",
    props: [
        "position"
    ]
}
</script>
